<script setup lang="ts">
import { userModule } from '@/store/user/module'
import { computed, onMounted, useTemplateRef } from 'vue'
import UIKit from '@pocketprep/ui-kit'

const {
    ModalContainer,
    Button: PocketButton,
} = UIKit

const props = defineProps<{
    numOfAnsweredQuestions: number
    numOfAssignmentQuestions: number
}>()

const numOfAnsweredQuestions = props.numOfAnsweredQuestions
const numOfAssignmentQuestions = props.numOfAssignmentQuestions

const emit = defineEmits<{
    'viewAssignmentResults': []
}>()

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})

const titleEl = useTemplateRef('past-due-assignment-modal__title')

onMounted(() => {
    setTimeout(() => {
        titleEl.value?.focus()
    }, 500)
})

const viewAssignmentResults = () => {
    emit('viewAssignmentResults')
}
</script>

<template>
    <Portal to="modal">
        <ModalContainer
            key="pastDueAssignmentModal"
            :show-close-button="false"
            :is-dark-mode="isDarkMode"
        >
            <div class="past-due-assignment-modal">
                <h1
                    ref="past-due-assignment-modal__title"
                    class="past-due-assignment-modal__title"
                    tabindex="-1"
                >
                    Time's Up
                </h1>
                <div class="past-due-assignment-modal__text">
                    The due date for this assignment just passed.
                    Your assignment will be submitted now.
                    You answered {{ numOfAnsweredQuestions }} of {{ numOfAssignmentQuestions }}
                    question{{ numOfAssignmentQuestions > 1 ? 's' : '' }}.
                    Unanswered questions are marked incorrect.
                </div>
                <PocketButton
                    class="past-due-assignment-modal__view-results-btn"
                    :is-dark-mode="isDarkMode"
                    @click="viewAssignmentResults"
                >
                    View Results
                </PocketButton>
            </div>
        </ModalContainer>
    </Portal>
</template>

<style lang="scss" scoped>
.past-due-assignment-modal {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 35px 41px 26px 38px;
    width: 384px;
    margin: 0 auto;

    &__title {
        font-weight: 600;
        font-size: 18px;
        margin: 0 0 12px 0;
        outline: none;
        line-height: 25px;
        letter-spacing: 0.3px;
    }

    &__text {
        color: $ash;
        font-size: 15px;
        line-height: 20px;
        text-align: center;
        margin-bottom: 32px;

        &--dark {
            color: $fog;
        }
    }
}
</style>
